import React, { useEffect } from "react";
import AgencySalesByUserProperties from "./AgencySalesByUserProperties";
import { useStyles } from "./AgencySalesByUser.style";
import AgencySalesByUserStore from "./AgencySalesByUserStore";
import { useCommonContext } from "../../../contexts/CommonContext";
import { Observer } from "mobx-react-lite";
import PageLoading from "../../../ui_components/PageLoading/PageLoading";
import { useI18nContext } from "../../../contexts/I18nContext";
import InfoIcon from "@mui/icons-material/Info";
import PriceLockup from "../../../ui_components/PriceLockup/PriceLockup";
import ShowSellerBasicInfo from "../../Info/ShowSellerBasicInfo/ShowSellerBasicInfo";
import SaleByUserResponse from "../../../model/sales/SaleByUserResponse";
import ExpandoMenu from "../../../ui_components/ExpandoMenu/ExpandoMenu";
import DownloadAgencySellersSalesReportButton from "../../Buttons/DownloadAgencySellersSalesReportButton/DownloadAgencySellersSalesReportButton";
import { useUserContext } from "../../../contexts/UserContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ButtonType from "../../../ui_components/Button/ButtonType";
import DownloadSellerSalesReportButton from "../../Buttons/DownloadSellerSalesReportButton/DownloadSellerSalesReportButton";
import { Chip } from "@material-ui/core";
import GroupIcon from "@mui/icons-material/Group";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { CurrencyModule } from "../../../util/Currency";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

const AgencySalesByUser: React.FC<AgencySalesByUserProperties> = ({
  from,
  to,
  agencyId,
  title,
  className = "",
}) => {
  const i18n = useI18nContext();
  const commonStore = useCommonContext();
  const userStore = useUserContext();
  const store = new AgencySalesByUserStore(commonStore, from, to, agencyId);
  const classes = useStyles();

  useEffect(() => {
    store.getElements();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [from, to]);

  const SellerRow: React.FC<SaleByUserResponse> = (data) => {
    return (
      <div className={classes.seller_row_container}>
        <div className={classes.item_row}>
          <ShowSellerBasicInfo
            autofill
            name={data.userName}
            email={data.userEmail}
          />
          <PriceLockup
            value={data.data.breakdown.reduce((t, c) => t + c.total, 0)}
            size={20}
            theme={"primary"}
            orders={data.data.breakdown.reduce((t, c) => t + c.amount, 0)}
            title={"Total de ventas"}
          />
          <div className={classes.item_sales_container}>
            {data.data.breakdown.map((dd, ii) => (
              <PriceLockup
                key={ii}
                value={dd.total}
                title={i18n.translate(dd.serviceName)}
                total={data.data.breakdown.reduce((t, c) => t + c.total, 0)}
                size={15}
                orders={dd.amount}
                theme={"success"}
              />
            ))}
          </div>
          <ExpandoMenu>
            <>
              {/* <SellerSalesOverviewButton
                                sellerId={data.userId}
                                from={from || 0}
                                to={to || 0}
                            /> */}
              <DownloadSellerSalesReportButton
                type={ButtonType.SECONDARY}
                sellerId={data.userId}
                from={from}
                to={to}
                size={ButtonSize.SMALL}
                showPreview
              />
            </>
          </ExpandoMenu>
        </div>
      </div>
    );
  };

  return (
    <Observer>
      {() => (
        <div className={classes.container}>
          <div className={classes.title}>
            <div>{title}</div>
            <div className={classes.title_options}>
              {store.sales && (
                <div className={classes.chips_container}>
                    <Chip
                        icon={<GroupIcon fontSize="small" />}
                        label={store.sales.breakdown.length}
                        size="small"
                        className={classes.chip}
                        variant="outlined"
                    />
                    <Chip
                        icon={<MonetizationOnIcon fontSize="small" />}
                        label={CurrencyModule.format(
                            store.sales.breakdown.reduce(
                            (total, seller) =>
                                total +
                                seller.data.breakdown.reduce((t, s) => t + s.total, 0),
                            0
                            )
                        )}
                        size="small"
                        className={classes.chip}
                        variant="outlined"
                    />
                    <Chip
                        icon={<ShoppingCartIcon fontSize="small" />}
                        label={store.sales.breakdown.reduce(
                            (total, seller) =>
                            total +
                            seller.data.breakdown.reduce((t, s) => t + s.amount, 0),
                            0
                        )}
                        size="small"
                        className={classes.chip}
                        variant="outlined"
                    />
                </div>
                )}
              <div>
                <ExpandoMenu fillBackgroundColor={false}>
                  <>
                    <DownloadAgencySellersSalesReportButton
                      agencyId={userStore.currentUser()?.agencyId}
                      from={from || 0}
                      to={to || 0}
                      showPreview
                    />
                  </>
                </ExpandoMenu>
              </div>
            </div>
          </div>
          <div className={classes.item_row_container}>
            {store.sales &&
              store.sales.breakdown.map((d, i) => <SellerRow key={i} {...d} />)}
          </div>
          {store.sales?.breakdown.length === 0 && (
            <div
              className={classes.no_content_container}
              onClick={() => store.getElements()}
            >
              <InfoIcon />
              {i18n.translate("NO_SALES")}
            </div>
          )}
          <PageLoading
            className={classes.loading_container}
            loadingSize={40}
            isLoading={store.loading}
            text={`${i18n.translate("LOADING")} ${title || ""}`}
          />
        </div>
      )}
    </Observer>
  );
};

export default AgencySalesByUser;
